export default "__VITE_ASSET__DQ34pmq3__"